const SESSION_VARIABLES = (state = [], action) => {
  switch (action.type) {
    case "ADD_KEY":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "AMMEND_KEY":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "DELETE_KEY":
      const { [action.payload.key]: removedKey, ...newObj } = state;
      return newObj;
    case "RESET_KEYS":
      return [];
    default:
      return state;
  }
};

export default SESSION_VARIABLES;
